/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { motion } from "framer-motion";

import { Layer } from "@vienna/common";

import { Plate } from "src/classes/plate/Plate";
import { CursorSvg } from "src/components/UI/Cursors/CursorSVG";
import { stringToHSL } from "src/lib/utils/color";

interface Props {
  plate: Plate;
  color: string;
}

// Spring animated cursor
export function Cursors({ plate }: Props) {
  const cursors = plate.socket.observe((state) => state.mice);

  return (
    <>
      {!!cursors.length &&
        cursors.map((cursor) => {
          const { x, y } = cursor.mousePosition;
          return (
            <motion.div
              key={cursor.username}
              style={{
                position: "absolute",
                top: "0",
                left: "0",
                zIndex: Layer.WIN_LAYER,
              }}
              initial={{ x, y }}
              animate={{ x, y }}
              transition={{
                type: "spring",
                damping: 30,
                mass: 0.8,
                stiffness: 350,
              }}
            >
              <CursorSvg color={stringToHSL(cursor.username, {})} />
            </motion.div>
          );
        })}
    </>
  );
}
